import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class AlertComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    
  }

  @Input() type: 'success' | 'warning' | 'error' | 'info' = 'info';
  isVisible = true;

  closeAlert() {
    this.isVisible = false;
  }

  // Dynamic icon image
  get icon(): string {
    switch (this.type) {
      case 'success': return 'assets/images/success.svg';
      case 'warning': return 'assets/images/warning.svg';
      case 'error':   return 'assets/images/alarm.svg';
      case 'info':    return 'assets/images/info.svg';
      default: return '';
    }
  }

}
